import { JobQueuePage } from '@client/components/_business/jobs/JobQueuePage';
import type { JobData } from '@client/components/_business/jobs/JobTable';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/jobs/recurring')({
    staticData: {
        breadcrumb: { title: 'Recurring jobs' },
        ui: {
            title: 'Recurring jobs',
            subtitle: 'System-wide scheduled background jobs that run on a regular interval',
            widthVariant: 'default',
            menuDescription: 'Scheduled system jobs',
        },
    },
    component: RecurringJobs,
});

function RecurringJobs() {
    const navigate = useNavigate();

    const handleJobClick = (job: JobData) => {
        if (job?.id) {
            navigate({ to: '/admin-console/advanced/jobs/recurring/$jobId', params: { jobId: job.id.toString() } });
        }
    };

    return (
        <JobQueuePage
            route={Route}
            jobType="recurring"
            documentTitle="Recurring jobs"
            searchPlaceholder="Search by ID, name, status, or error..."
            onJobClick={handleJobClick}
        />
    );
}
